/*
  Mock data only. No backend integration yet.
  Replace with API calls later via /api endpoints.
*/

export const HERO_IMAGES = {
  primary:
    "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/ncoc028j_2.gif",
  secondary:
    "https://images.unsplash.com/photo-1523419415305-08f0b1a7a85e?q=80&w=1600&auto=format&fit=crop",
};

export const PROJECTS = [
  {
    id: "eda-paris-2024",
    title: "Economat des Armées",
    modalTitle: "Base Temporaire - Paris",
    sector: "Base Temporaire",
    area: 1700,
    city: "Paris",
    image: "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/hb1f3pg1_00-%20FR%20-Profile%20Bimcubes_Page_03.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/hb1f3pg1_00-%20FR%20-Profile%20Bimcubes_Page_03.jpg",
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/4p6kty4f_00-%20FR%20-Profile%20Bimcubes_Page_04.jpg"
    ],
    badges: ["LOD 200", "Méthode", "4D"],
  },
  {
    id: "gp-paris-2024",
    title: "Toit du Grand Palais - Paris",
    subtitle: "Maintenance antennes",
    sector: "Patrimoine",
    area: 0,
    city: "Paris",
    image: "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/qj90kv2i_00-%20FR%20-Profile%20Bimcubes_Page_05.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/qj90kv2i_00-%20FR%20-Profile%20Bimcubes_Page_05.jpg",
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/kaop046m_00-%20FR%20-Profile%20Bimcubes_Page_06.jpg"
    ],
    badges: ["LOD 200", "Maintenance", "Antennes"],
  },
  {
    id: "syndics-kwarto-2024",
    title: "Toits Terrasses - Syndics",
    subtitle: "Kwarto - France",
    sector: "Maintenance",
    area: 30000,
    city: "France",
    image: "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/m4dpqb2e_00-%20FR%20-Profile%20Bimcubes_Page_07.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/m4dpqb2e_00-%20FR%20-Profile%20Bimcubes_Page_07.jpg",
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/wroj0tf5_00-%20FR%20-Profile%20Bimcubes_Page_08.jpg",
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/qj6za3vt_00-%20FR%20-Profile%20Bimcubes_Page_09.jpg"
    ],
    badges: ["LOD 200", "Maintenance"],
  },
  {
    id: "puit-marche-paris-650",
    title: "Puit du Marché",
    subtitle: "Paris - C2ODA",
    sector: "EXE",
    area: 650,
    city: "Paris",
    image: "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/fcr33xks_00-%20FR%20-Profile%20Bimcubes_Page_10.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/fcr33xks_00-%20FR%20-Profile%20Bimcubes_Page_10.jpg",
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/a1ec6ngk_00-%20FR%20-Profile%20Bimcubes_Page_11.jpg",
      "https://customer-assets.emergentagent.com/job_quotebuilder-3/artifacts/5gsurynk_00-%20FR%20-Profile%20Bimcubes_Page_12.jpg"
    ],
    badges: ["LOD 350", "Phase EXE"],
  },
  {
    id: "gare-dissy-3200",
    title: "Gare d'Issy",
    subtitle: "Paris - EXE",
    sector: "EXE",
    area: 3200,
    city: "Paris",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/n36x84h9_00-%20FR%20-Profile%20Bimcubes_Page_13.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/n36x84h9_00-%20FR%20-Profile%20Bimcubes_Page_13.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/7dro0qrc_00-%20FR%20-Profile%20Bimcubes_Page_14.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/rmdv1jvl_00-%20FR%20-Profile%20Bimcubes_Page_15.jpg"
    ],
    badges: ["LOD 350", "Phase EXE", "Revit 3D"],
  },
  {
    id: "charonne-paris-3500",
    title: "Projet Charonne",
    subtitle: "Paris - DCE",
    sector: "DCE",
    area: 3500,
    city: "Paris",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/2h1qpy3v_00-%20FR%20-Profile%20Bimcubes_Page_16.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/2h1qpy3v_00-%20FR%20-Profile%20Bimcubes_Page_16.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/wzl0lx3r_00-%20FR%20-Profile%20Bimcubes_Page_17.jpg"
    ],
    badges: ["LOD 300", "Phase DCE", "Revit 3D", "CVC", "Plomberie", "Electricité"],
  },
  {
    id: "six-flags-80000",
    title: "Six Flags",
    subtitle: "Arabie Saoudite - EXE",
    sector: "EXE",
    area: 80000,
    city: "Arabie Saoudite",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/sqtnm0zc_00-%20FR%20-Profile%20Bimcubes_Page_18.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/sqtnm0zc_00-%20FR%20-Profile%20Bimcubes_Page_18.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/6nmeomp7_00-%20FR%20-Profile%20Bimcubes_Page_19.jpg"
    ],
    badges: ["LOD 350", "Synthèse BIM", "Revit 3D", "CVC", "Plomberie", "Electricité"],
  },
  {
    id: "aqua-raffles-15000",
    title: "Aqua Raffles",
    subtitle: "Arabie Saoudite - EXE",
    sector: "EXE",
    area: 15000,
    city: "Arabie Saoudite",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/thvh6vcx_00-%20FR%20-Profile%20Bimcubes_Page_20.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/thvh6vcx_00-%20FR%20-Profile%20Bimcubes_Page_20.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/vs4zmuni_00-%20FR%20-Profile%20Bimcubes_Page_21.jpg"
    ],
    badges: ["LOD 350", "Revit 3D", "CVC", "Plomberie", "Electricité"],
  },
  {
    id: "renad-academy-37000",
    title: "Renad Academy",
    subtitle: "Qatar - DCE",
    sector: "DCE",
    area: 37000,
    city: "Qatar",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/pxoj9p9h_00-%20FR%20-Profile%20Bimcubes_Page_22.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/pxoj9p9h_00-%20FR%20-Profile%20Bimcubes_Page_22.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/pru855px_00-%20FR%20-Profile%20Bimcubes_Page_23.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/2pk6pqd2_00-%20FR%20-Profile%20Bimcubes_Page_24.jpg"
    ],
    badges: ["LOD 300", "Phase DCE", "Revit 3D", "Structure", "VRD", "CVC", "Plomberie", "Electricité", "Synthèse BIM", "4D"],
  },
  {
    id: "king-salman-pavilion-15000",
    title: "King Salman Pavilion",
    subtitle: "Arabie Saoudite - DCE",
    sector: "DCE",
    area: 15000,
    city: "Arabie Saoudite",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/fseosfp3_00-%20FR%20-Profile%20Bimcubes_Page_25.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/fseosfp3_00-%20FR%20-Profile%20Bimcubes_Page_25.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/5kdgpx6y_00-%20FR%20-Profile%20Bimcubes_Page_26.jpg"
    ],
    badges: ["LOD 300", "Synthèse BIM", "Phase DCE", "Revit 3D", "Architecture", "Structure", "CVC", "Plomberie", "Electricité", "VRD"],
  },
  {
    id: "norman-cay-30000",
    title: "Norman Cay",
    subtitle: "Iles Caymans - DCE",
    sector: "DCE",
    area: 30000,
    city: "Iles Caymans",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/k2lrh10v_00-%20FR%20-Profile%20Bimcubes_Page_27.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/k2lrh10v_00-%20FR%20-Profile%20Bimcubes_Page_27.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/0gj7cfon_00-%20FR%20-Profile%20Bimcubes_Page_28.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/hid69xxc_00-%20FR%20-Profile%20Bimcubes_Page_29.jpg"
    ],
    badges: ["LOD 300", "Revit 3D", "Architecture", "Agencement", "Structure", "CVC", "Plomberie", "Electricité", "Synthèse BIM"],
  },
  {
    id: "lusail-city-cp7b-1km2",
    title: "Lusail City CP7B",
    subtitle: "Qatar - DCE",
    sector: "DCE",
    area: 1000000,
    city: "Qatar",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/fx46t4ax_00-%20FR%20-Profile%20Bimcubes_Page_30.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/fx46t4ax_00-%20FR%20-Profile%20Bimcubes_Page_30.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/i89s3dzn_00-%20FR%20-Profile%20Bimcubes_Page_31.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/ayc7a3ju_00-%20FR%20-Profile%20Bimcubes_Page_32.jpg"
    ],
    badges: ["LOD 300", "4D", "5D", "OPC", "Économie", "Architecture", "Structure", "CVC", "Plomberie", "Electricité", "Synthèse BIM"],
  },
  {
    id: "new-cyprus-museum-30000",
    title: "Nouveau Musée de Chypre",
    subtitle: "Chypre - APS",
    sector: "APS",
    area: 30000,
    city: "Chypre",
    image: "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/4y95dxkq_00-%20FR%20-Profile%20Bimcubes_Page_33.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/4y95dxkq_00-%20FR%20-Profile%20Bimcubes_Page_33.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/8i8wx916_00-%20FR%20-Profile%20Bimcubes_Page_34.jpg",
      "https://customer-assets.emergentagent.com/job_bimestimate-debug/artifacts/rmfvwbmz_00-%20FR%20-Profile%20Bimcubes_Page_35.jpg"
    ],
    badges: ["LOD 200", "Revit 3D", "Architecture", "Structure"],
  }
];

export const TRAININGS = [
  { id: "t1", title: "Initiation BIM pour MOA/MOE", duration: "1 jour", level: "Débutant", topics: ["Concepts BIM", "Processus", "IFC"] },
  { id: "t2", title: "Revit Architecture - Production", duration: "3 jours", level: "Intermédiaire", topics: ["Gabarits", "Familles", "Phasage"] },
  { id: "t3", title: "Coordination & Synthèse BIM", duration: "2 jours", level: "Avancé", topics: ["Clash", "BIMcollab", "Navisworks"] },
];

export const FAQS = [
  { q: "Comment est calculé le chiffrage ?", a: "Nous utilisons des paramètres clés (surface, LOD, disciplines, délai) pondérés par notre expérience. Cette version est une estimation indicative." },
  { q: "Puis-je télécharger une offre ?", a: "Oui, vous pouvez télécharger une offre instantanée au format HTML depuis l'outil. Dans la version finale, nous générerons un PDF signé." },
  { q: "Proposez-vous des formations intra ?", a: "Oui, toutes nos formations sont adaptables en intra-entreprise avec audit préalable." },
];

export const ESTIMATOR_DEFAULT = {
  projectType: "Neuf",
  area: 1000,
  lod: "300", // "200" | "300" | "350/400"
  discipline: ["Architecture", "Structure (Coffrage)"],
  urgency: "Standard",
  synthesis: false,
  plans: 0,
  loiPhase: "APD (Avant-projet détaillé)",
  specialSurfaces: { vrd: 0, paysagisme: 0, paysagismeElec: 0 },
  // Client info
  name: "",
  company: "",
  email: "",
  phone: "",
  clientAddress: "",
  // 4D defaults
  d4: {
    durationWeeks: 26,
    tasks: 80,
    linkLevel: "Moyen", // Basique | Moyen | Avancé
    updates: "Hebdomadaire", // Hebdomadaire | Bimensuelle
    planningTool: "MS Project", // MS Project | Primavera P6 | Autre
    meetingsPerMonth: 2,
    simulation: false,
    exportVideo: false,
  },
};

export const LOI_PHASES = [
  {
    key: "ESQ",
    label: "Esquisse / Faisabilité",
    loi: "LOI Basique",
    tip: "Fonctions principales uniquement (ex: Mur porteur, Chaudière).",
    factor: 0.8,
  },
  {
    key: "APS",
    label: "APS (Avant-projet sommaire)",
    loi: "LOI Moyen",
    tip: "Dimensions principales, performances visées (U-value, puissance).",
    factor: 0.9,
  },
  {
    key: "APD",
    label: "APD (Avant-projet détaillé)",
    loi: "LOI Détaillé",
    tip: "Matériaux définis, caractéristiques techniques, contraintes réglementaires.",
    factor: 1.0,
  },
  {
    key: "PROEXE",
    label: "PRO / EXE (Exécution)",
    loi: "LOI Complet",
    tip: "Références fabricants, performances réelles, données de maintenance.",
    factor: 1.15,
  },
  {
    key: "DOE",
    label: "DOE / Exploitation",
    loi: "LOI Operations",
    tip: "N° de série, documentation, plan de maintenance, garantie.",
    factor: 1.1,
  },
];